.appLayout {
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100dvh;
  gap: 0;
  align-items: stretch;
  padding: var(--mantine-spacing-xs) 0;
}

.appLayoutMainContainer {
  width: 100%;
  height: 100%;
  margin: 0 var(--mantine-spacing-xs);
}

.appLayoutMain {
  width: 100%;
  height: 100%;
  background-color: var(--theme-color-layout-background);
  border-radius: var(--mantine-radius-md);
  border: 1px solid var(--theme-color-content-outline);
  overflow: hidden;
}

.rightSidebar {
  height: calc(100dvh - 2 * var(--mantine-spacing-xs));
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: var(--mantine-spacing-xs);
  transition:
    width 0.3s ease-in-out,
    margin-right 0.1s ease-in-out 0.1s;
  overflow: hidden;

  &:empty {
    margin-right: 0;
  }
}

.rightSidebar > div {
  width: 250px;
  height: 100%;
  background-color: var(--theme-color-layout-background);
  border-radius: var(--mantine-radius-md);
  border: 1px solid var(--theme-color-content-outline);
}
